import React, { useContext } from 'react'
import Modal from 'modules/react/signup/Modal'
import Step1RightContent from 'modules/react/signup/for-self/Step1RightContent'
import RightContent from 'modules/react/signup/RightContent'
import LeftContent from 'modules/react/signup/LeftContent'
import SignupContext from 'modules/react/signup/SignupContext'
import WhenStep from 'modules/react/signup/conditionals/WhenStep'
import Step2Unemployed from 'modules/react/signup/for-self/Step2Unemployed'
import Step2Employed from 'modules/react/signup/for-self/Step2Employed'
import SignupCompleted from 'modules/react/signup/for-self/SignupCompleted'
import Step3Unemployed from './Step3Unemployed'
import Step1RightContentDynamic from 'modules/react/signup/Step1RightContentDynamic'

export default function SignupContent () {
  const [employmentType, setEmploymentType] = React.useState(null)

  const signupContext = useContext(SignupContext)

  const { goToNextStep, cleanUp, setModal, buttonText, setEnterCallback, useCustomRightContent } = signupContext

  React.useEffect(() => {
      setEnterCallback(() => goToNextStep)
    }, []
  )

  const modalRef = React.createRef()

  React.useEffect(() => {
    setModal(modalRef?.current)
  }, [modalRef?.current])

  return (
    <>
      <button className="button button--full-width"
              onClick={() => modalRef.current.open()}>{buttonText ? buttonText : 'Tilmeld'}</button>
      <Modal ref={modalRef} onCloseCallback={cleanUp}>
        <WhenStep is={1}>
          <LeftContent>
            <div className="title title--h3">Er du ledig eller i job?</div>
            <div className="wysiwyg">
              Inden du tilmelder dig et AMU-kursus har vi brug for at vide, om du er i arbejde eller ledig.
            </div>
            <div className="title title--h6">Vælg</div>
            <div className="radio-group radio-group--large-group">
              <div className="radio-button">
                <input type="radio" value="unemployed" id="unemployed" name="employment_type"
                       defaultChecked={employmentType === 'unemployed'}
                       onChange={(e) => setEmploymentType(e.target.value)}/>
                <label htmlFor="unemployed">Jeg er ledig</label>
              </div>
              <div className="radio-button">
                <input type="radio" value="employed" id="employed" name="employment_type"
                       defaultChecked={employmentType === 'employed'}
                       onChange={(e) => setEmploymentType(e.target.value)}/>
                <label htmlFor="employed">Jeg er i job</label>
              </div>
            </div>
            <div className="button-section button-section--modal-group">
              <button className="button button--next" onClick={goToNextStep} disabled={employmentType === null}>
                Næste
              </button>
            </div>
          </LeftContent>
          <RightContent>
            {useCustomRightContent ? <Step1RightContentDynamic/> : <Step1RightContent/>}
          </RightContent>
        </WhenStep>

        <WhenStep is={2}>
          <>
            {employmentType === 'employed' && (
              <Step2Employed/>
            )}
            {employmentType === 'unemployed' && (
              <Step2Unemployed/>
            )}
          </>
        </WhenStep>

        <WhenStep is={3}>
          {employmentType === 'unemployed' && (
            <Step3Unemployed/>
          )}
        </WhenStep>

        <WhenStep is={4}>
          {employmentType === 'unemployed' && (
            <SignupCompleted/>
          )}
        </WhenStep>
      </Modal>
    </>
  )
}